<template>
  <div class="app-container">
    <div class="screeBox">
      <el-select
        filterable
        style="margin-right: 10px"
        v-model="screen.park_id"
        placeholder="请选择园区"
        :disabled="userInfo.park_id != 0"
      >
        <el-option label="全部" value=""></el-option>
        <el-option
          :label="item.name"
          :value="item.id"
          v-for="(item, index) in parkList"
          :key="index"
        ></el-option>
      </el-select>
      <el-input
        class="screenInput"
        v-model="screen.title"
        placeholder="请输入标题"
      ></el-input>
      <el-input
        class="screenInput"
        v-model="screen.devices"
        placeholder="请输入标签"
      ></el-input>
      <el-select
        filterable
        style="margin-right: 10px"
        v-model="screen.is_up"
        placeholder="请选择是否上架"
      >
        <el-option label="全部" value=""></el-option>
        <el-option label="上架" value="1"></el-option>
        <el-option label="下架" value="2"></el-option>
      </el-select>
      <el-button
        type="primary"
        @click="(screen.page = 1), fetchData()"
        style="margin-bottom: 5px"
        >搜索</el-button
      >
      <el-button
        type="primary"
        plain
        @click="reset()"
        style="margin-bottom: 5px"
        >重置</el-button
      >
    </div>
    <div style="margin-top: 10px">
      <el-button
        type="primary"
        @click="addMenu(0)"
        style="margin-bottom: 5px"
        v-if="roles.includes('/place/huiyishi_add')"
        >添加</el-button
      >
    </div>

    <el-table
      max-height="700"
      v-loading="listLoading"
      :header-cell-style="{ background: '#F2F3F5', color: '#606266' }"
      :data="list"
      element-loading-text="Loading"
      fit
      highlight-current-row
      stripe
      class="table-box"
      tooltip-effect="dark"
      row-key="id"
      :tree-props="{ children: 'nodes', hasChildren: 'hasChildren' }"
    >
      <el-table-column align="center" label="序号" width="95">
        <template slot-scope="scope">
          <!-- {{ scope.$index + 1 }} -->
          {{ (screen.page - 1) * screen.page_size + scope.$index + 1 }}
        </template>
      </el-table-column>
      <el-table-column prop="id" label="ID" width="100"> </el-table-column>

      <el-table-column label="所属园区" min-width="150">
        <template slot-scope="scope">
          <span>{{ scope.row.park ? scope.row.park.name : "" }}</span>
        </template>
      </el-table-column>
      <!-- <el-table-column label="类型" min-width="150">
        <template slot-scope="scope">
          <span>{{ scope.row.type == 1 ? '共享空间' : "智慧农场会场" }}</span>
        </template>
      </el-table-column> -->
      <el-table-column label="标题" min-width="210">
        <template slot-scope="scope">
          <span>{{ scope.row.title }}</span>
        </template>
      </el-table-column>
      <el-table-column label="联系电话" min-width="160">
        <template slot-scope="scope">
          <span>{{ scope.row.phone }}</span>
        </template>
      </el-table-column>
      <el-table-column label="封面图" width="150" >
        <template slot-scope="scope">
          <el-image
            v-for="(img, ind) in scope.row.picurl.split(',')"
            :key="ind"
            style="width: 120px; height: 40px; margin: 0 5px 5px 0"
            :src="imageOss + img"
            fit="contain"
            :preview-src-list="$pathDispose(scope.row.picurl.split(','))"
          >
          </el-image>
        </template>
      </el-table-column>
      <el-table-column label="标签" min-width="110">
        <template slot-scope="scope">
          <span>{{ scope.row.devices }}</span>
        </template>
      </el-table-column>
      <el-table-column label="最小容纳人数" width="120">
        <template slot-scope="scope">
          <span>{{ scope.row.min_num }}</span>
        </template>
      </el-table-column>
      <el-table-column label="最大容纳人数"  width="120">
        <template slot-scope="scope">
          {{ scope.row.max_num }}
        </template>
      </el-table-column>
      <el-table-column label="排序">
        <template slot-scope="scope">
          {{ scope.row.sort }}
        </template>
      </el-table-column>
      <el-table-column label="详细地址">
        <template slot-scope="scope">
          <div class="line2">{{ scope.row.address }}</div>
        </template>
      </el-table-column>
      <el-table-column label="上下架状态" min-width="100" align="center">
        <template slot-scope="scope">
          <!-- <span>{{ scope.row.role_type == 1 ? '后台' : '小程序' }}</span> -->
          <el-tag
            :type="scope.row.is_up == '1' ? 'success' : 'danger'"
            disable-transitions
            >{{ scope.row.is_up == 1 ? "上架" : "下架" }}</el-tag
          >
        </template>
      </el-table-column>
      <el-table-column prop="created_at" label="操作" width="260" fixed="right">
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="warning"
            @click="handleInfo(scope.row)"
            v-if="roles.includes('/place/huiyishi_info')"
            >查看</el-button
          >
          <el-button
            size="mini"
            type="success"
            @click="handleEdit(scope.row)"
            v-if="roles.includes('/place/huiyishi_edit')"
            >编辑</el-button
          >
          <el-button
            size="mini"
            type="danger"
            @click="handleDelete(scope.row.id)"
            v-if="roles.includes('/place/huiyishi_del')"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="screen.page"
      :page-sizes="[15, 30, 50]"
      :page-size="screen.page_size"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      style="margin-top: 10px"
    >
    </el-pagination>
    <el-drawer
      size="800px"
      :title="drawerTitle"
      :visible.sync="drawer"
      direction="rtl"
      :before-close="handleClose"
    >
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="140px"
        class="demo-ruleForm"
      >
        <el-form-item label="选择园区" prop="park_id">
          <el-select
            filterable
            :clearable="true"
            v-model="ruleForm.park_id"
            placeholder="请选择园区"
            @change="parkChange"
            :disabled="cztype == 'see' || userInfo.park_id != 0"
          >
            <el-option
              :label="item.name"
              :value="item.id"
              v-for="(item, index) in parkList"
              :key="index"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="选择服务" prop="service_ids">
          <el-select
            filterable
            multiple
            collapse-tags
            v-model="ruleForm.service_ids"
            placeholder="请选择服务"
            :disabled="cztype == 'see'"
          >
            <el-option
              :label="item.title"
              :value="item.id"
              v-for="(item, index) in serviceList"
              :key="index"
            ></el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="类型" prop="type">
          <el-radio-group v-model="ruleForm.type" :disabled="cztype == 'see'">
            <el-radio :label="1">共享空间</el-radio>
            <el-radio :label="2">智慧农场会场</el-radio>
          </el-radio-group>
        </el-form-item> -->
        <el-form-item label="标题" prop="title">
          <el-input
            :disabled="cztype == 'see'"
            class="w4"
            v-model="ruleForm.title"
            placeholder="请输入标题"
          ></el-input>
        </el-form-item>
        <el-form-item label="联系电话" prop="phone">
          <el-input
            class="w4 numInput"
            type="number"
            :disabled="cztype == 'see'"
            v-model="ruleForm.phone"
            placeholder="请输入联系电话"
          ></el-input>
        </el-form-item>
        <el-form-item label="硬件设备唯一标识" prop="unique_num" v-if="ruleForm.park_id == YUNZOUID">
          <el-select
            filterable
            :clearable="true"
            v-model="ruleForm.unique_num"
            placeholder="请选择硬件设备唯一标识"
            :disabled="cztype == 'see'"
          >
            <el-option
              :label="item.name"
              :value="item.unique_num"
              v-for="(item, index) in meetingList"
              :key="index"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="标签" prop="desList">
          <span slot="label"><span style="color: #f00">*</span> 标签</span>
          <el-button
            v-if="cztype != 'see'"
            size="mini"
            type="primary"
            @click="addDes()"
            >添加标签</el-button
          >
          <div>
            <div class="tabBox" v-for="(item, index) in desList" :key="index">
              <el-input
                style="width: 200px"
                :disabled="cztype == 'see'"
                v-model="item.val"
                placeholder="请输入标签"
              ></el-input>
              <i
                v-if="cztype != 'see' && desList.length > 1"
                class="el-icon-delete"
                style="margin-left: 20px"
                @click="delDes(index)"
              ></i>
            </div>
          </div>
          <span style="color: #f00" v-show="tabShow">请输入标签</span>
        </el-form-item>
        <el-form-item label="封面图" prop="picurl">
          <el-upload
            name="file[]"
            :limit="1"
            :data="{ type: 'image' }"
            class="avatar-uploaders1"
            :action="ossUpload"
            accept=".jpg,.png,.jpeg"
            :headers="{ token: token }"
            list-type="picture-card"
            :show-file-list="true"
            :file-list="fileList"
            :on-remove="picurlHandleRemovePic"
            :on-success="picurlHandleAvatarSuccess"
            :disabled="cztype == 'see'"
            :class="ruleForm.picurl ? 'hide' : ''"
          >
            <i class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="轮播图" prop="thumb">
          <el-upload
            class="avatar-uploaders1"
            :action="ossUpload"
            accept=".jpg,.png,.jpeg"
            name="file[]"
            :data="{ type: 'image' }"
            :headers="{ token: token }"
            list-type="picture-card"
            :show-file-list="true"
            :file-list="thumbFileList"
            :on-remove="handleRemovePic"
            :on-success="handleAvatarSuccess"
            :before-upload="beforeAvatarUpload"
            :disabled="cztype == 'see'"
            :class="cztype == 'see' ? 'hide' : ''"
          >
            <i class="el-icon-plus avatar-uploader-icon"></i> </el-upload
          ><!-- 已修改 -->
        </el-form-item>
        <!-- <el-form-item label="租金单价" prop="money">
          <el-input
            class="w4 numInput"
            type="number"
            :disabled="cztype == 'see'"
            @input="
              ruleForm.money = (
                ruleForm.money
                  .replace(/[^\d|\.]/g, '')
                  .replace(/^00/g, '0')
                  .replace(/^\./g, '0.')
              )
            "
            v-model="ruleForm.money"
            placeholder="请输入租金单价"
            ><template slot="append">元/h</template></el-input
          >
        </el-form-item> -->
        <el-form-item label="最小容纳人数" prop="min_num">
          <el-input
            class="w4 numInput"
            type="number"
            :disabled="cztype == 'see'"
            v-model="ruleForm.min_num"
            placeholder="请输入租最小容纳人数"
            ><template slot="append">人</template></el-input
          >
        </el-form-item>
        <el-form-item label="最大容纳人数" prop="max_num">
          <el-input
            class="w4 numInput"
            type="number"
            :disabled="cztype == 'see'"
            v-model="ruleForm.max_num"
            placeholder="请输入最大容纳人数"
            ><template slot="append">人</template></el-input
          >
        </el-form-item>
        <el-form-item label="详细地址" prop="address">
          <el-input
            type="textarea"
            :rows="2"
            class="w4"
            :disabled="cztype == 'see'"
            v-model="ruleForm.address"
            placeholder="请输入详细地址"
          ></el-input>
        </el-form-item>
        <el-form-item label="排序" prop="sort">
          <el-input
            class="w4 numInput"
            :disabled="cztype == 'see'"
            v-model="ruleForm.sort"
            placeholder="请输入排序"
            type="number"
          ></el-input>
        </el-form-item>
        <el-form-item label="详细介绍" prop="content">
          <Editor
            :disabled="cztype == 'see'"
            ref="myQuillEditor"
            style="width: 100%"
            v-model="ruleForm.content"
          />
        </el-form-item>
        <el-form-item label="禁用时间段">
          <el-button
            v-if="cztype != 'see'"
            size="mini"
            type="primary"
            @click="addTime()"
            >添加时间段</el-button
          >
          <div
            style="margin-top: 20px; display: flex; align-items: center;gap:5px"
            v-for="(item, index) in ruleForm.time_bucket"
            :key="item.now"
          >
          <el-time-picker
            :disabled="cztype == 'see'"
            is-range
            v-model="item.timeArr"
            format="HH:mm"
    value-format="HH:mm"
            range-separator="至"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            placeholder="选择时间范围">
          </el-time-picker>
            <!-- <div>
              <el-form-item
                :prop="'time_bucket.' + index + '.start_time'"
                :rules="{
                  required: true,
                  message: '开始时间不能为空',
                  trigger: 'blur',
                }"
              >
                <el-time-select
                class="timeWidth"
                  :disabled="cztype == 'see'"
                  placeholder="开始时间"
                  v-model="item.start_time"
                  :picker-options="{
                    start: '00:00',
                    step: '00:01',
                    end: '24:00',
                  }"
                >
                </el-time-select>
              </el-form-item>
            </div>
            <div class="line" :span="2">至</div>
            <div>
              <el-form-item
                :prop="'time_bucket.' + index + '.end_time'"
                :rules="{
                  required: true,
                  message: '结束时间不能为空',
                  trigger: 'blur',
                }"
              >
                <el-time-select
                class="timeWidth"
                  :disabled="cztype == 'see'"
                  placeholder="结束时间"
                  v-model="item.end_time"
                  :picker-options="{
                    start: '00:00',
                    step: '00:01',
                    end: '24:00',
                    minTime: item.start_time,
                  }"
                >
                </el-time-select>
              </el-form-item>
            </div> -->
            <!-- <div>
              <el-form-item
                :prop="'time_bucket.' + index + '.price'"
                :rules="{
                  required: true,
                  message: '租金不能为空',
                  trigger: 'blur',
                }"
              >
                <el-input
                  class="numInput" 
                  style="width:150px"
                  type="number"
                  :disabled="cztype == 'see'"
                  @blur="
                    item.price = Number(item.price
                      .replace(/[^\d|\.]/g, '')
                      .replace(/^00/g, '0')
                      .replace(/^\./g, '0.')).toFixed(2)
                  "
                  v-model="item.price"
                  placeholder="请输入租金"
                  ><template slot="append">元</template></el-input
                >
              </el-form-item>
            </div>
            <div>
              <el-form-item
                :prop="'time_bucket.' + index + '.sort'"
              >
                <el-input
                  class="numInput"
                  style="width:150px"
                  type="number"
                  :disabled="cztype == 'see'"
                  v-model="item.sort"
                  placeholder="请输入排序"
                  ><template slot="append">排序</template></el-input
                >
              </el-form-item>
            </div> -->
            <i
              v-if="cztype != 'see'&&ruleForm.time_bucket.length > 1"
              class="el-icon-delete line"
              style="margin-left: 20px"
              @click="delTime(index)"
            ></i>
          </div>
        </el-form-item>
        <el-form-item label="上下架状态" prop="is_up">
          <el-radio-group v-model="ruleForm.is_up" :disabled="cztype == 'see'">
            <el-radio :label="1">上架</el-radio>
            <el-radio :label="2">下架</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="提前多少分钟预约" prop="early_min">
          <el-input
            class="w4 numInput"
            :disabled="cztype == 'see'"
            v-model="ruleForm.early_min"
            placeholder="请输入"
            type="number"
          ></el-input>
        </el-form-item>
        <el-form-item label="最少预约多少分钟" prop="keep_min">
          <el-input
            class="w4 numInput"
            :disabled="cztype == 'see'"
            v-model="ruleForm.keep_min"
            placeholder="请输入"
            type="number"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button
            v-if="cztype == 'add'"
            type="primary"
            @click="submitForm('ruleForm')"
          >
            立即创建
          </el-button>
          <el-button
            v-if="cztype == 'edit'"
            type="primary"
            @click="editForm('ruleForm')"
          >
            修改
          </el-button>
          <el-button
            v-if="cztype == 'edit'"
            type="info"
            @click="drawer = false"
          >
            取消
          </el-button>
          <el-button
            v-if="cztype == 'add'"
            type="info"
            @click="resetForm('ruleForm')"
            >取消</el-button
          >
        </el-form-item>
      </el-form>
    </el-drawer>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Editor from "@/components/Editor";
import { openPark, delImage } from "@/api/index";
import {
  meeting_lists,
  meeting_info,
  meeting_add,
  meeting_edit,
  meeting_del,
  meeting_service_list,
  get_meeting_auth
} from "@/api/sharedOffice";
import { getToken } from "@/utils/auth";
export default {
  components: { Editor },
  computed: {
    ...mapGetters(["roles", "userInfo", "imageUrl", "imageOss"]),
  },
  data() {
    return {
      YUNZOUID:process.env.VUE_APP_YUNZHOU,
      dialogVisible: false,
      userLoading: true,
      token: getToken(),
      list: [],
      meetingList:[],
      listLoading: true,
      drawer: false,
      drawerTitle: "添加",
      screen: {
        page: 1,
        page_size: 15,
        park_id: "",
        devices: "",
        title: "",
        is_up: "",
      },
      typeList: [],
      total: 0,
      ruleForm: {},
      fileList: [],
      thumbFileList: [],
      clearThumb: [],
      rules: {
        park_id: [{ required: true, message: "请选择园区", trigger: "change" }],
        thumb: [{ required: true, message: "请选择轮播图" }],
        service_ids: [
          { required: true, message: "请选择服务", trigger: "change" },
        ],
        picurl: [{ required: true, message: "请选择封面图片" }],
        devices: [{ required: true, message: "请输入设备" }],
        sort: [{ required: true, message: "请输入排序", trigger: "blur" }],
        title: [{ required: true, message: "请输入标题", trigger: "blur" }],
        phone: [
          { required: true, message: "请输入联系电话", trigger: "blur" },
          {
            validator: (rule, value, callback) => {
              var reg = /^1[3456789]\d{9}$/;
              if (!reg.test(value)) {
                callback("请输入正确联系电话");
              } else {
                callback();
              }
            },
            trigger: "blur",
          },
          ],
        content: [
          { required: true, message: "请输入详细介绍", trigger: "blur" },
        ],
        address: [
          { required: true, message: "请输入详细地址", trigger: "blur" },
        ],
        min_num: [
          { required: true, message: "请输入最小容纳人数", trigger: "blur" },
        ],
        max_num: [
          { required: true, message: "请输入最大容纳人数", trigger: "blur" },
        ],
        contact_phone: [
          { required: true, message: "请输入联系电话", trigger: "blur" },
        ],
        early_min: [
          { required: true, message: "请输入提前多少分钟预约", trigger: "blur" },
        ],
        keep_min: [
          { required: true, message: "请输入最少预约多少分钟", trigger: "blur" },
        ],
        unique_num: [
          { required: true, message: "请选择硬件设备唯一标识", trigger: "change" },
        ],
        is_up: [
          { required: true, message: "请选择上下架状态", trigger: "change" },
        ]
      },
      cztype: "",
      ossUpload: this.$store.state.ossUpload,
      parkList: [],
      serviceList: [],
      clearPics: [],
      registerUser: {
        id: "",
        page: 1,
        page_size: 15,
        total: 0,
      },
      registerUserList: [],
      formTypeList: [],
      percentage: 0,
      percentageShow: true,
      desList: [
        {
          val: "",
        },
      ],
      tabShow: false,
      start_time: "",
      end_time: "",
    };
  },
  created() {
    if (this.userInfo.park_id !== 0) {
      this.screen.park_id = this.userInfo.park_id;
    } else {
      this.screen.park_id = "";
    }
    this.fetchData();
    this.getPark();
  },
  methods: {
    // 获取权限点
    getMeeting(parkId){
      get_meeting_auth({park_id:parkId,is_page:2}).then(res =>{
        console.log(res,'fffww')
        this.meetingList = res.data.lists
      })
    },
    handleAvatarSuccess(res, file, fileList) {
      if (res.code === 200) {
        var list = [];
        list = fileList.map((item) => {
          return item.response.data.url;
        });
        this.ruleForm.thumb = list.join(",");
      } else {
        this.$message({
          message: res.msg,
          type: "error",
        });
        var list = [];
        fileList.map((item) => {
          if (item.response.code == 200) {
            list.push({
              name: +new Date(),
              url: imageOss + item.response.data.url,
              response: {
                data: {
                  url: item.response.data.url,
                },
              },
            });
          }
        });
        this.fileList = list;
      }
      // this.ruleForm.icon = URL.createObjectURL(file.raw)
    },
    // 比较时间段是否重叠
    Fn() {
      var that = this;
      for (let k in this.ruleForm.time_bucket) {
        if (!that.judege(k)) {
          return false;
        }
      }
      return true;
    },
    judege(idx) {
      for (let k in this.ruleForm.time_bucket) {
        if (idx !== k) {
          if (
            this.ruleForm.time_bucket[k].timeArr[0] <= this.ruleForm.time_bucket[idx].timeArr[0] &&
            this.ruleForm.time_bucket[k].timeArr[1] > this.ruleForm.time_bucket[idx].timeArr[0]
          ) {
            return false;
          }
          if (
            this.ruleForm.time_bucket[k].timeArr[0] < this.ruleForm.time_bucket[idx].timeArr[1] &&
            this.ruleForm.time_bucket[k].timeArr[1] >= this.ruleForm.time_bucket[idx].timeArr[1]
          ) {
            return false;
          }
        }
      }
      return true;
    },
    // 添加标签
    addDes() {
      this.desList.push({
        val: "",
      });
    },
    delDes(index) {
      this.desList.splice(index, 1);
    },
    // 添加时间段
    addTime() {
      this.ruleForm.time_bucket.push({
        start_time: "",
        end_time: "",
        price: "",
        sort:0,
        now:Date.now()+Math.random(),
        timeArr:null
      });
    },
    delTime(index) {
      this.ruleForm.time_bucket.splice(index, 1);
    },
    picurlHandleRemovePic(file, fileList) {
      this.fileList = [];
      this.ruleForm.picurl = "";
    },
    handleRemovePic(file, fileList) {
      if (file.response.data.url) {
        this.clearPics.push(file.response.data.url);
      }
      var list = [];
      list = fileList.map((item) => {
        return item.response.data.url;
      });
      this.ruleForm.thumb = list.join(",");
    },
    delImges() {
      if (this.clearPics.length) {
        delImage({ file: this.clearPics.join(",") }).then((ress) => {});
      }
      if (this.clearThumb.length) {
        delImage({ file: this.clearThumb.join(",") }).then((ress) => {});
      }
    },
    beforeAvatarUpload(file) {
      const isLt5M = file.size / 1024 / 1024 < 5;
      if (!isLt5M) {
        this.$message.error("上传图片大小不能超过 5MB!");
      }
      return isLt5M;
    },
    picurlHandleAvatarSuccess(res, file, fileList) {
      if (res.code === 200) {
        this.ruleForm.picurl = res.data.url;
      } else {
        this.$message({
          message: res.msg,
          type: "error",
        });
        var list = [];
        fileList.map((item) => {
          if (item.response.code == 200) {
            list.push({
              name: +new Date(),
              url: imageOss + item.response.data.url,
              response: {
                data: {
                  url: item.response.data.url,
                },
              },
            });
          }
        });
        this.fileList = list;
      }
      // this.ruleForm.icon = URL.createObjectURL(file.raw)
    },
    reset() {
      this.screen = {
        park_id: "",
        title: "",
        page: 1,
        page_size: 15,
        is_up: "",
        devices: "",
      };
      if (this.userInfo.park_id !== 0) {
        this.screen.park_id = this.userInfo.park_id;
      } else {
        this.screen.park_id = "";
      }
      this.fetchData();
    },
    handleSizeChange(val) {
      this.screen.page_size = val;
      this.screen.page = 1;
      this.fetchData();
    },
    handleCurrentChange(val) {
      this.screen.page = val;
      this.fetchData();
    },
    // 修改
    editForm(formName) {
      var that = this;
      var desList = [];
      let show = 0;
      that.desList.forEach((item) => {
        if (item.val) {
          desList.push(item.val);
        } else {
          show++;
        }
      });
      if (show != 0) {
        that.tabShow = true;
        return;
      } else {
        that.tabShow = false;
      }
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (!this.Fn()) {
            this.$message({
              type: "warning",
              message: "所选时间段不能重合",
            });
            return;
          }
          // let timeBucket = [];
          // that.ruleForm.time_bucket.forEach((item) => {
          //   timeBucket.push(item.start_time + "-" + item.end_time);
          // });
          this.$confirm("确认提交？")
            .then(() => {
              var data = {
                ...this.ruleForm,
                devices: desList.join(","),
                service_ids: this.ruleForm.service_ids.join(","),
                time_bucket: JSON.stringify(that.ruleForm.time_bucket),
              };
              meeting_edit(data).then((res) => {
                if (res.code === 200) {
                  this.$message({
                    message: res.msg,
                    type: "success",
                  });
                  that.delImges();
                  that.drawer = false;
                  that.fetchData();
                }
              });
            })
            .catch(() => {});
        } else {
          this.$nextTick(() => {
            that.elFormErrorScrollIntoView();
          });

          return false;
        }
      });
    },
    // 编辑
    handleEdit(val) {
      this.cztype = "edit";
      this.drawerTitle = "编辑";
      this.clearPics = [];
      this.fileList = [];
      this.thumbFileList = [];
      this.clearVideos = [];
      this.parkChange(val.park_id);
      this.getMeeting(val.park_id)
      this.getInfo(val.id);
      // this.drawer = true;
    },
    // 查看
    handleInfo(val) {
      this.cztype = "see";
      this.drawerTitle = "查看";
      this.clearPics = [];
      this.fileList = [];
      this.thumbFileList = [];
      this.clearVideos = [];
      this.parkChange(val.park_id);
      this.getMeeting(val.park_id)
      this.getInfo(val.id);

      // this.drawer = true;
    },
    // 获取信息
    getInfo(id) {
      var that = this;
      meeting_info({ id: id }).then((res) => {
        // this.domains = res.data.company_role_data
        that.ruleForm = {
          id: res.data.info.id,
          park_id: Number(res.data.info.park_id),
          title: res.data.info.title,
          devices: res.data.info.devices,
          sort: res.data.info.sort,
          picurl: res.data.info.picurl,
          thumb: res.data.info.thumb.join(","),
          money: res.data.info.money,
          min_num: res.data.info.min_num,
          max_num: res.data.info.max_num,
          address: res.data.info.address,
          content: res.data.info.content,
          service_ids: res.data.info.service_ids?res.data.info.service_ids.split(',').map(Number):[],
          is_up: res.data.info.is_up,
          phone: res.data.info.phone,
          time_bucket: [],
          early_min:res.data.info.early_min,
          keep_min:res.data.info.keep_min,
          unique_num:res.data.info.unique_num?res.data.info.unique_num:null
        };
        
        that.desList = [];
        if (res.data.info.devices) {
          let deslist = res.data.info.devices.split(",");
          deslist.forEach((item) => {
            that.desList.push({
              val: item,
            });
          });
        }
        if (res.data.info.place_time_bucket) {
          var tempTime = res.data.info.place_time_bucket
          for (let i = 0; i < tempTime.length; i++) {
            that.ruleForm.time_bucket.push({
              start_time: tempTime[i].show_time.split("-")[0],
              end_time: tempTime[i].show_time.split("-")[1],
              price: tempTime[i].price,
              sort:tempTime[i].sort,
              now: Date.now()+Math.random(),
              timeArr:tempTime[i].show_time.split("-")
            });
          }
        }

        if (res.data.info.picurl) {
          var list = res.data.info.picurl.split(",");
          this.fileList = list.map((item) => {
            return {
              name: +new Date(),
              url: this.imageOss + item,
              response: {
                data: {
                  url: item,
                },
              },
            };
          });
        }
        if (res.data.info.thumb) {
          this.thumbFileList = res.data.info.thumb.map((item) => {
            return {
              name: +new Date(),
              url: this.imageOss + item,
              response: {
                data: {
                  url: item,
                },
              },
            };
          });
        }
      });
      this.drawer = true;
    },
    // 删除
    handleDelete(id) {
      var that = this;
      this.$confirm("确认删除？")
        .then(() => {
          meeting_del({ id: id }).then((res) => {
            if (res.code == 200) {
              this.$message({
                message: "删除成功",
                type: "success",
              });
            }
            that.fetchData();
          });
        })
        .catch(() => {});
    },
    submitForm(formName) {
      // return;
      var that = this;
      var desList = [];
      let show = 0;
      that.desList.forEach((item) => {
        if (item.val) {
          desList.push(item.val);
        } else {
          show++;
        }
      });
      if (show != 0) {
        that.tabShow = true;
      }
      // return;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (!this.Fn()) {
            this.$message({
              type: "warning",
              message: "所选时间段不能重合",
            });
            return;
          }
          this.$confirm("确认提交？")
            .then(() => {
              // let timeBucket = [];
              that.ruleForm.time_bucket.forEach((item) => {
                item.start_time= item.timeArr[0]
                item.end_time= item.timeArr[1]
              });
              var data = {
                ...this.ruleForm,
                devices: desList.join(","),
                service_ids: this.ruleForm.service_ids.join(","),
                time_bucket: JSON.stringify(that.ruleForm.time_bucket),
              };
              meeting_add(data).then((res) => {
                if (res.code === 200) {
                  this.$message({
                    message: res.msg,
                    type: "success",
                  });
                  that.delImges();
                  that.drawer = false;
                  that.fetchData();
                }
              });
            })
            .catch(() => {});
        } else {
          this.$nextTick(() => {
            that.elFormErrorScrollIntoView();
          });

          return false;
        }
      });
    },
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then(() => {
          this.$nextTick(() => {
            this.$refs.ruleForm.clearValidate();
          });
          done();
        })
        .catch(() => {});
    },
    addMenu(id) {
      this.drawerTitle = "添加";
      this.cztype = "add";
      this.ruleForm = {
        park_id: "",
        title: "",
        devices: "",
        sort: 0,
        picurl: "",
        thumb: "",
        money: "",
        min_num: "",
        max_num: "",
        address: "",
        content: "",
        service_ids: [],
        is_up: 1,
        phone:"",
        time_bucket: [
          {
            start_time: "",
            end_time: "",
            price: "",
            sort:0,
            now:Date.now()+Math.random(),
            timeArr:null
          },
        ],
      };
      this.tabShow = false;
      this.clearPics = [];
      this.fileList = [];
      this.thumbFileList = [];
      this.desList = [
        {
          val: "",
        },
      ];
      this.clearThumb = [];
      if (this.userInfo.park_id !== 0) {
        this.ruleForm.park_id = this.userInfo.park_id;
      }
      this.$nextTick(() => {
        this.$refs.ruleForm.clearValidate();
      });
      this.drawer = true;
    },
    // 获取园区
    getPark() {
      this.parkList = [];
      openPark({ is_page: 2, status: 1 }).then((res) => {
        this.parkList = res.data.lists;
      });
    },
    parkChange(e) {
      this.ruleForm.service_ids = []
      if (e) {
        this.getService(e);
        this.getMeeting(e)
      }
    },
    getService(park_id) {
      meeting_service_list({ park_id, is_page: 0 }).then((res) => {
        if (res.code == 200) {
          this.serviceList = res.data;
        }
      });
    },
    // 重置
    resetForm(formName) {
      this.$refs.ruleForm.resetFields();
      this.drawer = false;
    },
    fetchData() {
      this.listLoading = true;
      meeting_lists(this.screen).then((response) => {
        this.list = response.data.data;
        this.total = response.data.total;
        this.listLoading = false;
      });
    },
  },
};
</script>
<style lang="scss" scoped>
// .el-button {
//   color: #000 !important;
// }
::v-deep .el-drawer__body {
  padding-right: 20px;
  overflow: auto;
}
.table-box {
  margin-top: 20px;
}
.video-box {
  width: 148px;
  height: 148px;
  position: relative;
  border-radius: 6px;
  overflow: hidden;
  video {
    width: 100%;
    height: 100%;
  }
  &:hover {
    .handles {
      opacity: 1;
    }
  }
  .handles {
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    z-index: 3;
    cursor: pointer;
    text-align: center;
    color: #fff;
    opacity: 0;
    font-size: 20px;
    background-color: rgba(0, 0, 0, 0.5);
    transition: opacity 0.3s;
    .el-icon-delete {
      font-size: 20px;
      color: #fff;
    }
  }
}
.avatar-uploaders {
  width: 80px;
  height: 80px;
  text-align: center;
  border: 1px solid #d9d9d9;
  line-height: 90px;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  text-align: center;
}
.tableIcon {
  width: 50px;
  height: 50px;
}
.screenInput {
  width: 200px;
  margin-right: 10px;
}
.timeWidth {
  width: 130px;
}
.w4 {
  width: 40%;
}
::v-deep .el-table .el-table__body td .cell:empty::after,
.el-table .el-table__body td .cell > span:empty::after,
.el-table .el-table__body td .cell .approval:empty::after,
.el-table .el-table__body td .cell div:empty::after,
.el-table .el-table__body td .cell .line-limit-length:empty::after {
  content: "--";
}
.numInput {
  ::v-deep .el-input__inner {
    padding-right: 0 !important;
  }
}

.hide {
  ::v-deep .el-upload--picture-card {
    display: none;
  }
}
//去除动画
::v-deep .el-list-enter-active,
::v-deep .el-list-leave-active {
  transition: all 0s;
}

.screeBox {
  border-bottom: 1px solid #e4e7ed;
  padding-bottom: 16px;
}
.tabBox {
  display: inline-block;
  margin-right: 10px;
  margin-bottom: 10px;
}
</style>
